export {
  formatCurrency,
  formatTvpi,
  formatIrr,
} from "../SnapshotSummary/utils"

// Muted BREE-friendly categorical palette for dense review screens.
export const CHART_PALETTE = [
  "#143764",
  "#3f7f93",
  "#b58b2a",
  "#5b6270",
  "#2e6f57",
  "#8f5f79",
  "#4878a8",
  "#9a6b3f",
  "#6d8b3d",
  "#7c6d9a",
  "#a35656",
  "#4f7a7d",
]

export const POSITIVE_COLOR = "#00b050"
export const NEGATIVE_COLOR = "#ff0000"

export const formatSigned = (
  value: number | null | undefined,
  suffix = "",
): string => {
  if (value == null) return "—"
  const sign = value > 0 ? "+" : ""
  return `${sign}${value}${suffix}`
}

export const colorFor = (index: number): string =>
  CHART_PALETTE[index % CHART_PALETTE.length]

export const colorClassFor = (index: number): string =>
  `b-portfolio-summary-color-${index % CHART_PALETTE.length}`

export const widthClassFor = (percent: number): string => {
  const clamped = Math.max(0, Math.min(100, percent))
  return `b-portfolio-summary-w-${Math.round(clamped / 5) * 5}`
}
